import React, { useState, useEffect } from "react";

const TextQuestion = ({ onSubmit, onNext, placeholder = "Type your answer...", initialValue, optional = false }) => {
  const [input, setInput] = useState("");
  const inputRef = React.useRef(null);

  // Set initial value when editing
  useEffect(() => {
    if (initialValue !== undefined && initialValue !== null) {
      // Convert to string if it's not already a string
      const stringValue = typeof initialValue === 'string' 
        ? initialValue 
        : (Array.isArray(initialValue) 
          ? initialValue.join(', ') 
          : String(initialValue));
      setInput(stringValue);
    }
  }, [initialValue]);

  // Delayed autofocus to allow smooth transition
  useEffect(() => {
    const timer = setTimeout(() => {
      // Focus without scrolling - we'll handle scroll separately in the parent component
      inputRef.current?.focus({ preventScroll: true });
    }, 300); // Delay to allow previous keyboard to close and transition to complete

    return () => clearTimeout(timer);
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();

    // Ensure input is a string
    const inputStr = String(input || "");
    
    // For optional questions, allow empty submissions
    if (!optional && inputStr.trim() === "") return;

    // Submit empty string for optional questions if no input, otherwise submit the input
    onSubmit(optional && inputStr.trim() === "" ? "" : inputStr);
    onNext();

    // Reset input
    setInput("");
  };

  // For optional questions, always allow submission (even if empty)
  // Ensure input is a string before calling trim
  const inputStr = String(input || "");
  const canSubmit = optional || inputStr.trim() !== "";

  return (
    <form onSubmit={handleSubmit} className="input-form">
      <div className="input-field-container">
        <textarea
          className="input-field"
          value={String(input || "")}
          onChange={(e) => setInput(e.target.value)}
          ref={inputRef}
          placeholder={placeholder}
          rows={3}
        />
        <button
          type="submit"
          className="send-button"
          disabled={!canSubmit}
        >
          <svg className="send-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 19V5m0 0l-7 7m7-7l7 7" />
          </svg>
        </button>
      </div>
    </form>
  );
};

export default TextQuestion; 